var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00004 1.16675C4.36823 1.16675 4.66671 1.46523 4.66671 1.83341V3.83341C4.66671 4.2016 4.36823 4.50008 4.00004 4.50008C3.63185 4.50008 3.33337 4.2016 3.33337 3.83341V1.83341C3.33337 1.46523 3.63185 1.16675 4.00004 1.16675ZM12 1.16675C12.3682 1.16675 12.6667 1.46523 12.6667 1.83341V3.83341C12.6667 4.2016 12.3682 4.50008 12 4.50008C11.6318 4.50008 11.3334 4.2016 11.3334 3.83341V1.83341C11.3334 1.46523 11.6318 1.16675 12 1.16675Z",
    fill: "#172B4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4.5C1 3.39543 1.89543 2.5 3 2.5H13C14.1046 2.5 15 3.39543 15 4.5V13.8333C15 14.9379 14.1046 15.8333 13 15.8333H3C1.89543 15.8333 1 14.9379 1 13.8333V4.5ZM2.33333 6.5V13.8333C2.33333 14.2015 2.63181 14.5 3 14.5H13C13.3682 14.5 13.6667 14.2015 13.6667 13.8333V6.5H2.33333Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.e0574c6e2e6b21910ff760ff7a326018.svg";
export { ForwardRef as ReactComponent };